<template>
  <div class="page-add">
    <div class="add-title">
      {{ addTitle }}
    </div>
    <el-form
      :model="ruleForm"
      ref="ruleForm"
      :rules="rules"
      label-width="130px"
      size="small"
      class="form"
    >
      <el-row>
        <el-col>
          <el-form-item class="scale" label=" APP是否展示：" required>
            <el-radio-group
              readonly
              v-model="ruleForm.isApp"
              :disabled="ruleForm.onlineStatus == 1"
            >
              <el-radio
                v-for="item in publicData"
                :key="item.paramKey"
                :label="item.paramKey"
                >{{ item.paramValue }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="scale" label=" WEB是否展示：" required>
            <el-radio-group
              readonly
              v-model="ruleForm.isWeb"
              :disabled="ruleForm.onlineStatus == 1"
            >
              <el-radio
                v-for="item in publicData"
                :key="item.paramKey"
                :label="item.paramKey"
                >{{ item.paramValue }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="scale" label=" 小程序是否展示：" required>
            <el-radio-group
              readonly
              v-model="ruleForm.isApplet"
              :disabled="ruleForm.onlineStatus == 1"
            >
              <el-radio
                v-for="item in publicData"
                :key="item.paramKey"
                :label="item.paramKey"
                >{{ item.paramValue }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="scale" label=" PC端是否展示：" required>
            <el-radio-group
              readonly
              v-model="ruleForm.isPc"
              :disabled="ruleForm.onlineStatus == 1"
            >
              <el-radio
                v-for="item in publicData"
                :key="item.paramKey"
                :label="item.paramKey"
                >{{ item.paramValue }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="文章标题：" prop="articleTitle">
        <el-input
          readonly
          placeholder="请输入文章标题"
          v-model="ruleForm.articleTitle"
        ></el-input>
      </el-form-item>

      <el-row>
        <el-col :span="12">
          <el-form-item label="所属期刊：" prop="periodicalName">
            <el-input
              readonly
              placeholder="请选择所属期刊"
              v-model="ruleForm.periodicalName"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="所属栏目："
            prop="subjectId"
            :rules="[
              { required: !!ruleForm.periodicalId, message: '请选择所属栏目' },
            ]"
          >
            <el-select
              v-model="ruleForm.subjectId"
              placeholder="请选择所属栏目"
              style="width: 100%"
              :disabled="true"
            >
              <el-option
                v-for="(item, i) in subjectList"
                :key="i"
                :label="item.subjectName"
                :value="item.uuid"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item
            label="期刊年份："
            prop="periodicalYear"
            :rules="[
              { required: !!ruleForm.periodicalId, message: '请选择期刊年份' },
            ]"
          >
            <el-select
              v-model="ruleForm.periodicalYear"
              placeholder="请选择年份"
              style="width: 100%"
              :disabled="true"
            >
              <el-option
                v-for="(item, i) in yearList"
                :key="i"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item
            label="期刊期次："
            prop="periodId"
            :rules="[
              { required: !!ruleForm.periodicalId, message: '请选择期次' },
            ]"
          >
            <el-select
              v-model="ruleForm.periodId"
              placeholder="请选择期次"
              style="width: 100%"
              :disabled="true"
            >
              <el-option
                v-for="(item, i) in periodList"
                :key="i"
                :label="item.currentPeriod"
                :value="item.uuid"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="作者：" prop="articleAuthor">
            <el-input
              readonly
              placeholder="请输入作者"
              v-model="ruleForm.articleAuthor"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="来源：" prop="newsSource">
            <el-input
              readonly
              placeholder="请输入来源"
              v-model="ruleForm.newsSource"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="发表时间：" prop="publishDate">
            <el-date-picker
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              v-model="ruleForm.publishDate"
              style="width: 100%"
              readonly
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="排序：" prop="order">
            <el-input-number
              disabled
              v-model="ruleForm.order"
              :min="0"
            ></el-input-number>
          </el-form-item> </el-col
      ></el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="解读链接：" prop="audioSetId">
            <el-input
              readonly
              placeholder="请选择推荐阅读文章"
              v-model="ruleForm.recommendNames"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="scale" label="附件：" prop="attachment">
            <upload
              :limit="10"
              :path="'periodicalArticle/attachment'"
              v-model="ruleForm.attachmentList"
              :disabled="true"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item
        label="文章内容："
        prop="articleContent"
        :rules="{ required: true, message: '请输入文章内容' }"
        :show-message="showError"
      >
        <weditor
          :detail.sync="ruleForm.articleContent"
          uploadUrl="periodicalArticle/richText"
        />
      </el-form-item>
      <el-form-item label-width="0" class="center">
        <back-button :pathOptions="pathOptions" :floatLeft="false" />
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import {
  articleInfo,
  articleSave,
  articleUpdate,
} from "@/api/periodicalArticle";
import { getArticleList, getList } from "@/api/periodicalInfo";
import { periodList, periodYearList } from "@/api/periodicalPeriod";
import { subjectList } from "@/api/periodicalSubject";
import { getSysParamByTypes } from "@/api/sysParam";
import BackButton from "@/components/backButton/index.vue";
import { Confirm } from "@/components/Confirm";
import weditor from "@/components/weditor/index";
import Upload from "@/components/upload/index";
import { setItem } from "@/utils/storage.js";

export default {
  components: { weditor, BackButton, Upload },
  data() {
    return {
      pathOptions: {
        path: "/periodicalArticle",
      },
      command: function () {},
      ruleForm: {
        articleTitle: "",
        periodId: "",
        periodicalId: "",
        periodicalName: "",
        recommendIds: [],
        subjectId: "",
        articleAuthor: "",
        newsSource: "",
        publishDate: "",
        articleContent: "",
        periodicalYear: "",
        order: "",
        isApplet: "",
        isApp: "",
        isWeb: "",
        isPc: "",
        attachmentList: [],
      },
      periodicalList: [],
      subjectList: [],
      yearList: [],
      periodList: [],
      subjectDisabled: true, //栏目是否可用
      yearDisabled: true, //年份是否可用
      periodDisabled: true, //期次是否可用
      addTitle: "新增期刊文章",
      editFlag: false,
      edituuid: "",
      showError: true,
      selVideo: [],
      rules: {
        articleTitle: [
          {
            required: true,
            message: "请输入文章标题",
            trigger: ["blur", "change"],
          },
        ],
        // periodicalId: [
        //   {
        //     required: true,
        //     message: "请选择所属期刊",
        //     trigger: ["blur", "change"],
        //   },
        // ],
      },
      page: 1,
      more: true,
      data: [],
      articleMore: true,
      publicData: [],
    };
  },
  created() {
    this.getSysParamByTypes(["IS_VALID"]);
    if (this.$route.query.uuid) {
      this.addTitle = "期刊文章详情";
      this.editFlag = true;
      this.command = articleUpdate;
      articleInfo(this.$route.query.uuid).then((res) => {
        if (!res || res.code != 0) return;
        this.ruleForm = res.data;
        this.ruleForm.isApp = String(res.data.isApp);
        this.ruleForm.isWeb = String(res.data.isWeb);
        this.ruleForm.isApplet = String(res.data.isApplet);
        this.ruleForm.isPc = String(res.data.isPc);
        // 转换附件格式
        if (this.ruleForm.attachment) {
          this.ruleForm.attachmentList = JSON.parse(this.ruleForm.attachment);
        } else {
          this.ruleForm.attachmentList = [];
        }
        this.ruleForm.recommendNames
          ? (this.ruleForm.recommendNames =
              this.ruleForm.recommendNames.split(","))
          : "";
        this.edituuid = res.data.uuid;

        let id = this.ruleForm.periodicalId;
        let year = this.ruleForm.periodicalYear;
        if (id != null && id != "" && year != null && year != null) {
          this.getSubjectList(id);
          this.getYearList(id);
          this.getPeriodList(id, year);

          this.subjectDisabled = false;
          this.yearDisabled = false;
          this.periodDisabled = false;
        }
      });
    } else {
      this.addTitle = "新增期刊文章";
      this.editFlag = false;
      this.command = articleSave;
    }
  },
  mounted() {},
  methods: {
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({ types: types }).then((res) => {
        if (!res || res.code != 0) return;
        this.publicData = res.data["IS_VALID"] || [];
        // if (!this.$route.query.uuid) {
        this.ruleForm.isApp = this.publicData[1].paramKey;
        this.ruleForm.isWeb = this.publicData[1].paramKey;
        this.ruleForm.isApplet = this.publicData[1].paramKey;
        this.ruleForm.isPc = this.publicData[1].paramKey;
        // }
      });
    },
    changeCon(data) {
      this.ruleForm.articleContent = data;
      if (!this.ruleForm.articleContent) {
        this.showError = true;
      } else {
        this.showError = false;
      }
    },
    goBack() {
      this.$router.back();
    },
    getSubjectList(id) {
      if (id == null || id == "") {
        return;
      }
      subjectList(id).then((res) => {
        if (res && res.code == 0) {
          this.subjectList = res.data;
        }
      });
    },
    getYearList(id) {
      periodYearList(id).then((res) => {
        if (res && res.code == 0) {
          this.yearList = res.data;
        }
      });
    },
    getPeriodList(id, year) {
      periodList(id, year).then((res) => {
        if (res && res.code == 0) {
          this.periodList = res.data;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.form-select {
  width: 100%;
  &.has-btn {
    width: calc(100% - 110px);
  }
}
/deep/ .el-tag.el-tag--info .el-tag__close {
  display: none;
}
.center {
  text-align: center;
}
</style>
